module.exports = __webpack_public_path__ + "static/media/TRIAL1.05e44c8a.mp3";